"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReasonDefined = exports.isReschedulingSuccess = void 0;
const isReschedulingSuccess = '@guards/IS_RESCHEDULING_SUCCESS';
exports.isReschedulingSuccess = isReschedulingSuccess;
const isReasonDefined = '@guards/IS_REASON_DEFINED';
exports.isReasonDefined = isReasonDefined;
exports.default = {
    // Checks if rescheduling is successful
    [isReschedulingSuccess]: (_, event) => event.data.data.status === 'success',
    [isReasonDefined]: (context) => {
        return (context.rescheduleReasons !== undefined &&
            context.rescheduleReasons.length > 0);
    }
};
//# sourceMappingURL=guards.reasonMachine.js.map